import GoalError from './GoalError';
class TimeToGoalMustBeMoreThanZero extends GoalError {
    constructor(options) {
        super('Time to goal is less than or equal to zero when the goal type is TIME', options);
    }
}
export default TimeToGoalMustBeMoreThanZero;
